import { expandBaseWebBorder, expandBorderRadii, expandPadding } from "@gadgetinc/themes/src/utils";
import { styled } from "baseui";

export const FlatCard = styled<{ $spaced?: boolean }, "div">("div", ({ $theme, $spaced }) => {
  return {
    ...($spaced ? expandPadding($theme.sizing.scale1000) : {}),
    ...expandBorderRadii($theme.sizing.scale300),
    ...expandBaseWebBorder({
      borderWidth: "3px",
      borderColor: $theme.colors.primary,
      borderStyle: "solid",
    }),
    height: "100%",
    boxShadow: `0 3px 0 0 ${$theme.colors.primary}`,
    backgroundColor: $theme.colors.backgroundPrimary,
  };
});
